import { getCurrentUser } from "aws-amplify/auth";
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from "react-router-dom";
import { loginActions } from '../../pages/LoginPage/reducer';
import { selectHasPermissions, selectLoadingUser, selectPermissions } from '../../util/store/selectors';
import { useSelector } from '../../util/store/store';
import { PATHNAME } from "../../util/varibles/constants";
import { IPropsChildren } from "../../util/varibles/interface";
import MessageMini from "../Chat/MessageMini";
import LoadingPage from '../LoadingPage';
import Header from "./Header";

export const requireAuth = (children: ReactNode | ReactElement, actionId?: string) => <RequireAuth actionId={actionId}>
    {children}
</RequireAuth>;

interface IProps extends IPropsChildren {
    actionId?: string
}

const RequireAuth: React.FC<IProps> = ({ children, actionId }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [hasPermission = true] = useSelector(selectPermissions(actionId ? [actionId] : []));
    const hasPermissions = useSelector(selectHasPermissions);
    const loadingUser = useSelector(selectLoadingUser);
    const [state, setLoading] = useState(0);

    useEffect(() => {
        async function checkLogin() {
            try {
                const user = await getCurrentUser();
                if (user)
                    setLoading(1)
                else {
                    setLoading(-1)
                    dispatch(loginActions.logout());
                }
                return true;
            } catch (err) {
                setLoading(-1)
                dispatch(loginActions.logout());
                return false;
            }
        }
        checkLogin();
    }, [dispatch])

    if (state < 0) {
        return <Navigate to={PATHNAME.LOGIN} state={{ from: location }} replace />;
    }
    if (!state) {
        return <LoadingPage />;
    }
    if (actionId && !hasPermission) {
        if (loadingUser)
            return <LoadingPage />
        if (hasPermissions)
            return <Navigate to={PATHNAME.ACCESS_DENIED} state={{ from: location }} replace />;
    }

    return <>
        <Header />
        <MessageMini />
        {children}
    </>;
};

export default RequireAuth;
